import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsAdd = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="M11 13H5v-2h6V5h2v6h6v2h-6v6h-2z" />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsAdd);
const Memo = memo(ForwardRef);
export default Memo;
